import { DADATA_PROXY_SUGGEST_FIO } from '@alfa-bank/site-envconfig';

export const URL = DADATA_PROXY_SUGGEST_FIO();
export const HEADERS = {
    Accept: 'application/json',
};
